import WithRender from "../../templates/base/costCenter.html";
import { mapGetters, mapActions } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getCostCenter", "getShowCostCenter"]),
    name: () => {
      return "Cost Center Number:";
    },
    costCenter: {
      get: function () {
        return this.getCostCenter;
      },
      set: function (newValue) {
        this.setCostCenter(newValue);
      }
    }
  },
  methods: {
    ...mapActions(["setCostCenter"])
  }
});
